export const NAME = 'OutstandingRevenue';
export const CRUMB_LABEL_KEY = 'lstOutstandingRevenue';
export { DMS_MODULE } from '../constants';

export enum TAB_NAMES {
	OpenServiceOrder = 'OPEN_SERVICE_ORDER',
	OpenPartSaleOrder = 'OPEN_PART_SALE_ORDER',
}

export const TABS = {
	[TAB_NAMES.OpenServiceOrder]: { id: TAB_NAMES.OpenServiceOrder, labelKey: 'OPEN_SERVICE_ORDER' },
	[TAB_NAMES.OpenPartSaleOrder]: { id: TAB_NAMES.OpenPartSaleOrder, labelKey: 'OPEN_PART_SALE_ORDER' },
};

export const OUTSTANING_REVENUE_SERVICE_ORDER = 'OutstandingRevenueOpenServiceOrder';
export const OUTSTANING_REVENUE_PART_SALE_ORDER = 'OutstandingRevenueOpenPartSaleOrder';

export const DEPENDENT_TABLES = <const>[
	OUTSTANING_REVENUE_SERVICE_ORDER,
	OUTSTANING_REVENUE_PART_SALE_ORDER,
];
export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export const entityId = '1';
export const MAX_DAYS = 31;
export const MIN_DAYS = 0;

export const LOADED = 'Loaded';
export const OPEN_SERVICE_ORDER = 'Open Service Order';
export const OPEN_PART_SALE_ORDER = 'Open Part Sale Order';